import { render, staticRenderFns } from "./AmazonPay.vue?vue&type=template&id=4ba2e2f0&scoped=true"
import script from "./AmazonPay.vue?vue&type=script&lang=js"
export * from "./AmazonPay.vue?vue&type=script&lang=js"
import style0 from "./AmazonPay.vue?vue&type=style&index=0&id=4ba2e2f0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba2e2f0",
  null
  
)

export default component.exports